module.exports = __webpack_public_path__ + "static/for_whom_cooperative_banks-87ec8175267ddc8c111e0b88fc92f67b.jpg";